
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  on: {
    pageBeforeIn: function () {
      this.$app.statusbar.setBackgroundColor('#ffffff');
      this.$app.statusbar.setTextColor('black');
    }
  },
  id: 'c97902dd03',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page listing-page" data-name="all-specialities">\n        <div class="navbar">\n            <div class="navbar-bg"></div>\n            <div class="navbar-inner sliding">\n                <div class="left">\n                    <a href="#" class="link back" aria-label="Back">\n                        <i class="icon icon-back"></i>\n                    </a>\n                </div>\n                <div class="title">All Specialities</div>\n            </div>\n        </div>\n        <div class="page-content">\n            ';
      r += Template7Helpers.js_if.call(ctx_1, 'this.data && this.data.length', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <div class="listing-intro">\n                <div class="listing-intro-title">Find a doctor by speciality</div>\n                <div class="listing-intro-sub">Choose a department to see available doctors.</div>\n            </div>\n            <div class="tile-grid">\n                ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.data, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                <a href="/doctors/';
              r += c(ctx_3.id, ctx_3);
              r += '/';
              r += c(ctx_3.name, ctx_3);
              r += '/" class="tile-card" aria-label="';
              r += c(ctx_3.name, ctx_3);
              r += '">\n                    <div class="tile-card-icon">\n                        <img src="';
              r += c(ctx_3.image_url, ctx_3);
              r += '" alt="" onerror="this.src=\'static/img/default_icon.svg\'">\n                    </div>\n                    <div class="tile-card-name">';
              r += c(ctx_3.name, ctx_3);
              r += '</div>\n                </a>\n                ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n            </div>\n            ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <div class="empty-state">\n                <img src="static/img/default_icon.svg" alt="">\n                <div class="empty-state-title">No specialities available</div>\n                <div class="empty-state-sub">Please check back in a little while.</div>\n            </div>\n            ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n        </div>\n    </div>\n';
      return r;
    }(this);
  },
  styleScoped: false
};
    